import { Orientation } from "@buildwithflux/models";
const { HORIZONTAL, VERTICAL } = Orientation;
export class WireProjectionSimple {
    project(from, to) {
        return [
            { position: from.position },
            { direction: HORIZONTAL, position: { x: to.position.x, y: from.position.y } },
            { direction: VERTICAL, position: { ...to.position } },
        ];
    }
}
//# sourceMappingURL=WireProjectionSimple.js.map